import { cond, isNil } from 'ramda'

export const convertStatus = (status: number) => {
  return cond([
    [isNil, () => ''],
    [() => status === -1, () => '刪除'],
    [() => status === 0, () => '未啟用'],
    [() => status === 1, () => '啟用'],
  ])(status)
}
